import { GR_NEW_ADDRESS_LOAD, GR_NEW_ADDRESS_LOAD_SUCCESS, GR_NEW_ADDRESS_LOAD_FAIL, ADDRESS_SEARCH_LOAD, ADDRESS_SEARCH_LOAD_SUCCESS, FLUSH_ADDRESS_SEARCH, ADDRESS_SEARCH_LOAD_FAIL,UPDATE_DELIVERY_ADDRESS } from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GR_NEW_ADDRESS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case GR_NEW_ADDRESS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case GR_NEW_ADDRESS_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case ADDRESS_SEARCH_LOAD:
      return {
        ...state,
        addressSearchLoading: true,
        loading: true,
      };
    case ADDRESS_SEARCH_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        addressSearchLoading: false,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case FLUSH_ADDRESS_SEARCH: {
      return Object.assign({}, state, action.data);
    }
    case ADDRESS_SEARCH_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        addressSearchLoading: false,
        data: null,
        error: action.error,
      };
      case UPDATE_DELIVERY_ADDRESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        addressSearchLoading: false, 
        data :{
          deliveryAddressInfo:action.data,
          status: { status: 'success', errorCode: "",errorMessage:""}
        }     
        
      };
    default:
      return state;
  }
}
